import { useState } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { Text } from 'react-aria-components';
import BlockTitle from 'src/components/ui/BlockTitle';
import PageLoader from 'src/components/ui/PageLoader';
import EmptyState from 'src/components/ui/EmptyState';
import TextField from 'src/components/ui/TextField';
import BackButton from 'src/components/BackButton';
import useCoursesList from 'src/hooks/useCoursesList';

const ExpiredCoursesPage = () => {
  const [filter, setFilter] = useState('');

  const { courses: expiredCourses, loading } = useCoursesList({
    expired: true,
    skip: false,
    filter,
  });

  if (loading) return <PageLoader />;

  return (
    <>
      <div className="px-6 py-4">
        <BackButton to="/dashboard" />
      </div>
      <div className="bg-surface-alt rounded-3xl shadow-3 px-2 pt-4 pb-6">
        <TextField
          aria-label="Filter"
          size="small"
          className="m-3"
          placeholder="Search expired courses"
          value={filter}
          onChange={(value) => setFilter(value)}
        />

        {expiredCourses.length > 0 ? (
          <>
            <BlockTitle variant="v2" className="mt-8 mb-4 px-4">
              Expired Courses
            </BlockTitle>
            {expiredCourses.map((course) => (
              <div
                key={course.courseId}
                className="px-4 py-2 rounded-lg bg-surface"
              >
                <Text
                  elementType="strong"
                  className="block text-surface-alt-90 font-bold"
                >
                  {course.name}
                </Text>
                <Text className="text-surface-alt-75 text-sm font-semibold">
                  <span className="text-surface-alt-75">from</span>{' '}
                  {(course?.professors ?? [])
                    .map((p) => p.name)
                    .filter(Boolean)
                    .join(', ') || '-'}
                </Text>
                {course?.term?.name && (
                  <div className="flex items-center gap-2 pt-2">
                    <Text className="inline-block bg-surface-alt-ghost text-xs text-surface-alt-75 font-semibold px-2.5 py-1.5 rounded-lg capitalize">
                      {course.term.name}
                    </Text>
                  </div>
                )}
              </div>
            ))}
          </>
        ) : (
          <EmptyState
            message={
              filter.length > 0
                ? 'No expired courses found!'
                : NO_EXPIRED_COURSES
            }
            className="text-center px-10 min-h-[25rem]"
          />
        )}
      </div>
    </>
  );
};

const NO_EXPIRED_COURSES = 'You have no expired courses!';

export const Route = createFileRoute(
  '/_authenticated/_layout-advanced/expired-courses'
)({
  component: ExpiredCoursesPage,
});
